const OPPSourcingType = {
    SUGGESTED: 'SUGGESTED',
    CUSTOM: 'CUSTOM',
};
const LegacyFormattedLocationType = {
    STORE: 'STR',
    SURROUNDING_STORE: 'SS',
    HUB: 'HUB',
    LINKED_DISTRIBUTION_CENTER: 'LDC',
    DISTRIBUTION_CENTER: 'DC',
};
const LocationType = {
    STORE: 'STORE',
    DC: 'DC',
    SERVICING_HUB: 'SERVICING_HUB',
    OTHER_HUB: 'OTHER_HUB',
    LINKED_DC: 'LINKED_DC',
    SERVICING_DC: 'SERVICING_DC',
    SURROUNDING_STORE: 'SURROUNDING_STORE',
    ALL_SUPPLIERS: 'ALL_SUPPLIERS',
    OUT_OF_STOCK: 'OUT_OF_STOCK',
};

export { OPPSourcingType, LegacyFormattedLocationType, LocationType };
